import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { TryAgainButton } from './button';
import Description from './description';
import Title from './title';
export const ExceptionState = ({ children, className }) => {
    const classes = clsx(`flex flex-col items-center justify-center rounded-medium`, className);
    return _jsx("div", { className: classes, children: children });
};
ExceptionState.Title = Title;
ExceptionState.Description = Description;
ExceptionState.Button = TryAgainButton;
